var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_3151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3337 1.3335H5.33366C3.86033 1.3335 2.66699 2.52683 2.66699 4.00016V22.6668H5.33366V4.00016H21.3337V1.3335ZM25.3337 6.66683H10.667C9.19366 6.66683 8.00033 7.86016 8.00033 9.3335V28.0002C8.00033 29.4735 9.19366 30.6668 10.667 30.6668H25.3337C26.807 30.6668 28.0003 29.4735 28.0003 28.0002V9.3335C28.0003 7.86016 26.807 6.66683 25.3337 6.66683ZM25.3337 28.0002H10.667V9.3335H25.3337V28.0002Z",
    fill: "#4B4B4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_3151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.6babb94ce0058c8879a8a9444344d0ba.svg";
export { ForwardRef as ReactComponent };